module.exports = __webpack_public_path__ + "img/60.951ec91.jpg";